export type ManagedRole = 'STAFF' | 'ADMIN' | 'FINANCE' | 'FINANCE_LEAD' | 'HR' | 'IT_ADMIN';

export const ROLE_OPTIONS: { value: ManagedRole; label: string }[] = [
  { value: 'STAFF', label: 'Staff' },
  { value: 'ADMIN', label: 'Admin' },
  { value: 'FINANCE', label: 'Finance' },
  { value: 'FINANCE_LEAD', label: 'Finance Lead' },
  { value: 'HR', label: 'HR' },
  { value: 'IT_ADMIN', label: 'IT Admin' },
];

/** Mirrors the API rule: IT_ADMIN may grant any role; everyone else any role except IT_ADMIN. */
export function grantableRoles(viewerRole: ManagedRole | undefined) {
  return viewerRole === 'IT_ADMIN' ? ROLE_OPTIONS : ROLE_OPTIONS.filter((r) => r.value !== 'IT_ADMIN');
}

/** Only an IT_ADMIN may modify an IT_ADMIN account. */
export function canManageUser(viewerRole: ManagedRole | undefined, targetRole: ManagedRole) {
  return viewerRole === 'IT_ADMIN' || targetRole !== 'IT_ADMIN';
}

export function isOwnRow(viewerId: string | undefined, targetId: string) {
  return viewerId !== undefined && viewerId === targetId;
}
